import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { enableMapSet } from 'immer';
import App from './App';
import "./index.css";

// 启用 Immer MapSet 插件
enableMapSet();

Sentry.init({
    dsn: "https://c8d1439c842e1cab99cb0219404403e5@o4509371582906368.ingest.de.sentry.io/4509371585527888",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
  

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />,
);
